import { formatPluginName, parseParams } from '../../../common';
import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const addStructurePluginStmtInstruction = `

`;
export const stmtAddStructurePlugin = ({ pluginName, viewName, scopeName, params, }) => {
    const formatParams = params ? ` with ${params}` : '';
    if (!scopeName) {
        return `add plugin ${pluginName} in ${viewName}${formatParams};`;
    }
    return `add plugin ${pluginName} in ${viewName}.${scopeName}${formatParams};`;
};
export const addStructurePluginHandler = createStructureStatementHandler({
    type: 'add plugin',
    parse: line => {
        const match = /^(add|create) plugin (?<pluginName>[\w-]+) in (?<viewName>\w+)(\.(?<scopeName>\w+))?(?: with (?<params>[^;]+))?/.exec(line);
        return match?.groups
            ? {
                type: 'add plugin',
                pluginName: formatPluginName(match.groups.pluginName),
                viewName: match.groups.viewName,
                scopeName: match.groups.scopeName,
                params: parseParams(match.groups.params),
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => it.addPlugin({
            pluginName: stmt.pluginName,
            viewName: stmt.viewName,
            scopeName: stmt.scopeName,
            pluginParams: stmt.params,
        }));
    },
});
//# sourceMappingURL=AddPluginStmt.js.map